export function getLocalizedHref(href: string, locale: string) {
  // If href is external (starts with http or https), return as is
  if (href.startsWith('http')) {
    return href
  }

  // If href is anchor link (#), return as is
  if (href.startsWith('#')) {
    return href
  }

  // If href already starts with locale, return as is
  if (href.startsWith(`/${locale}/`)) {
    return href
  }

  // If href starts with /, add locale
  if (href.startsWith('/')) {
    return `/${locale}${href}`
  }

  // Default case: add locale with /
  return `/${locale}/${href}`
}
